export function clearUrlParam(key: string) {
  const url = new window.URL(document.location.href);
  url.searchParams.delete(key);
  history.replaceState(null, '', url);
}

export function getUrlParam(key: string) {
  const url = new window.URL(document.location.href);
  return url.searchParams.get(key);
}

export function getUrlParams() {
  const url = new window.URL(document.location.href);
  const params = {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  for (const [key, value] of url.searchParams.entries()) {
    params[key] = value;
  }
  return params;
}

export function addUrlParam(key: string, id: string) {
  const url = new window.URL(document.location.href);
  url.searchParams.set(key, id);
  return url.toString();
}

